import React from "react";
import "./NavBar.css";
import logo from "../../../assets/logo.png";

import { buildNavItems } from "../../../Utils/buildContext";

import LanguageDropdown from "./LanguageDropdown";
import HamburgerMenu from "./HamburgerMenu";
import DropdownNavItem from "./DropdownNavItem";

function NavBar({ lang, setLang }) {
  const navItems = buildNavItems(lang);

  return (
    <div className="navbar">
      <a className="navbar__left" href='#home'>
        <img src={logo} alt="Ankor Makina Logo"  />
      </a>

      <div className="navbar__right">
        <nav className="navbar__links" aria-label="Primary">
          {navItems.map((item) =>
            item.type === "dropdown" ? (
              <DropdownNavItem
                key={item.id}
                id={item.id}
                title={item.title}
                items={item.items}
              />
            ) : (
              <a key={item.href} href={item.href} 
                className={
                  item.href === "#laser-cut" || item.href === "#machining"
                    ? "navbar__link navbar__link--highlight"
                    : "navbar__link"
                }>
                {item.label}
              </a>
            )
          )}
        </nav>
        <LanguageDropdown lang={lang} setLang={setLang} />
        <HamburgerMenu lang={lang} navItems={navItems} />
      </div>
    </div>
  );
}

export default NavBar;

